import { SvgIconType } from './svg.interface';

const SendIcon: SvgIconType = ({
  width = 16,
  height = 16,
  className = '',
  color = '#30313D'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="send">
      <path
        id="Glyph"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.10765 9.78352L7 8.09999L1.16237 6.43209L0.031025 2.04252C-0.107068 1.50673 0.228771 0.963795 0.781141 0.829846C1.01119 0.77406 1.25403 0.796904 1.46874 0.89453L15.5333 7.28944C15.8181 7.41894 16 7.69654 16 8.00166C16 8.30678 15.8181 8.58437 15.5333 8.71387L1.46874 15.1088C0.953203 15.3432 0.33937 15.1278 0.0977097 14.6278C-0.00293604 14.4195 -0.0264872 14.1839 0.031025 13.9608L1.10765 9.78352Z"
        fill={color}
      />
    </g>
  </svg>
);

export default SendIcon;
